import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import AdminEditButtons from '../EditButtons';
import RoleSettings from '../Roles/RoleSettings';

import ErrorBoundary from '../../ErrorBoundary';

const AdminCustomFieldEditSettings = ({
  entity,
  entityId,
  handleChangeRole,
  handleDelete,
  ...props
}) => {
  const intl = useIntl();

  const handleChange = (roleId, permission, checked) => {
    handleChangeRole(roleId, permission, checked);
  };

  const permissions = [
    {
      key: 'can_view',
      label: intl.formatMessage({ defaultMessage: 'View' }),
    },
    {
      key: 'can_edit',
      label: intl.formatMessage({ defaultMessage: 'Edit' }),
    },
  ];

  return (
    <ErrorBoundary>
      <div className="tab-content-wrapper">
        <div>
          <p>
            {intl.formatMessage({ defaultMessage: 'Manage user role permissions' })}
          </p>
          <div className="settings-permissions">
            <RoleSettings
              permissions={permissions}
              handleChangeRole={handleChange}
              entity={entity}
              entityType="custom-field"
            />
          </div>
        </div>
      </div>
      <AdminEditButtons
        {...props}
        deleteText={intl.formatMessage({ defaultMessage: 'Delete Custom Field' })}
        hideDelete={entityId === null}
        handleDelete={handleDelete}
      />
    </ErrorBoundary>
  );
};

AdminCustomFieldEditSettings.propTypes = {
  entity: PropTypes.object,
  entityId: PropTypes.string,
  handleChangeRole: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

AdminCustomFieldEditSettings.defaultProps = {
  entity: null,
  entityId: null,
};

export default AdminCustomFieldEditSettings;
